import { create } from 'zustand';
import { MosaicNode } from 'react-mosaic-component';
import { ArtifactType } from '@/utils/artifactTypes';

export interface ArtifactHierarchy {
  UUID: string;
  VectorDBUrl: string;
  UserUUID: string;
  Content: string;
  Type: ArtifactType;
  ParentMsgUUID: string;
  Title: string;
}

interface artifactState {
  openedArtifact: boolean;
  actualArtifact: number | null;
  artifactTitle: string;
  artifactHierarchy: ArtifactHierarchy[];
  currentNode: MosaicNode<string> | null;
  isCodeWindowOpen: boolean;
  setOpenArtifact: (artifact: boolean) => void;
  setArtifactTitle: (title: string) => void;
  setArtifactHierarchy: (hierarchy: any[]) => void;
  setActualArtifact: (artifact: number) => void;
  setCurrentNode: (node: MosaicNode<string> | null) => void;
  setCodeWindowOpen: (isOpen: boolean) => void;
  updateLayoutBasedOnWindows: () => void;
}

export const useArtifactStore = create<artifactState>((set, get) => ({
  openedArtifact: false,
  artifactTitle: '',
  artifactHierarchy: [],
  actualArtifact: 0,
  currentNode: {
    direction: 'row',
    first: 'chat',
    second: 'artifact',
    splitPercentage: 100,
  },
  isCodeWindowOpen: false,

  setOpenArtifact: (artifact: boolean) => {
    set({ openedArtifact: artifact });
    get().updateLayoutBasedOnWindows();
  },

  setArtifactTitle: (title: string) => {
    set({ artifactTitle: title });
  },

  setArtifactHierarchy: (hierarchy: any[]) => {
    set({ artifactHierarchy: hierarchy });
  },

  setActualArtifact: (artifact: number) => {
    set({ actualArtifact: artifact });
  },

  setCurrentNode: (node: MosaicNode<string> | null) => {
    set({ currentNode: node });
  },

  setCodeWindowOpen: (isOpen: boolean) => {
    set({ isCodeWindowOpen: isOpen });
    get().updateLayoutBasedOnWindows();
  },

  updateLayoutBasedOnWindows: () => {
    const { openedArtifact, isCodeWindowOpen } = get();

    if (openedArtifact && isCodeWindowOpen) {
      // Three windows: chat, artifact, code
      set({
        currentNode: {
          direction: 'row',
          first: 'chat',
          second: {
            direction: 'column',
            first: 'artifact',
            second: 'code',
            splitPercentage: 50,
          },
          splitPercentage: 50,
        },
      });
    } else if (openedArtifact) {
      // Two windows: chat and artifact
      set({
        currentNode: {
          direction: 'row',
          first: 'chat',
          second: 'artifact',
          splitPercentage: 60,
        },
      });
    } else if (isCodeWindowOpen) {
      // Two windows: chat and code
      set({
        currentNode: {
          direction: 'row',
          first: 'chat',
          second: 'code',
          splitPercentage: 60,
        },
      });
    } else {
      // Only chat window
      set({ currentNode: 'chat' });
    }
  },
}));
